/* eslint-disable */
// @ts-nocheck
export function useHeaderZIndex() {
  const getHeader = () => document.querySelector('.site-header');

  const decreaseZIndex = () => {
    const header = getHeader();
    header?.style.setProperty('z-index', '1', 'important');
  };

  const increaseZIndex = () => {
    const header = getHeader();
    header?.style.setProperty('z-index', '1000', 'important');
  };

  return {
    decreaseZIndex,
    increaseZIndex,
  };
}
